export const CREATE_CLIENT_FORM = 'create-client-form';
